import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core'
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms'
import { Router } from '@angular/router'
import { Observable } from 'rxjs'
import { LangChangeEvent, TranslateService, TranslatePipe } from '@ngx-translate/core'

import { storageKeys } from '@constants/storage-keys'
import { KoodistoService } from '@services/koodisto.service'
import { License } from '@models/koodisto/license'
import { Title } from '@angular/platform-browser'
import { FocusRemoverDirective } from '../../../../directives/focus-remover.directive'
import { CollapseDirective } from 'ngx-bootstrap/collapse'
import { AsyncPipe } from '@angular/common'

@Component({
  selector: 'app-tabs-license',
  templateUrl: './license.component.html',
  imports: [ReactiveFormsModule, FocusRemoverDirective, CollapseDirective, AsyncPipe, TranslatePipe]
})
export class LicenseComponent implements OnInit, OnDestroy {
  @Output() abortEdit: EventEmitter<boolean> = new EventEmitter<boolean>()

  lang: string = this.translate.getCurrentLang()
  savedData: any
  licenses$: Observable<License[]> = this.koodistoService.licenses$
  form: FormGroup
  submitted: boolean = false

  constructor(
    private fb: FormBuilder,
    private koodistoService: KoodistoService,
    private translate: TranslateService,
    private router: Router,
    private titleService: Title
  ) {}

  ngOnInit(): void {
    this.setTitle()
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.lang = event.lang
      this.setTitle()
      this.koodistoService.updateLicenses()
    })
    this.savedData = JSON.parse(sessionStorage.getItem(storageKeys.newERLSKey))
    this.form = this.fb.group({
      license: this.fb.control(null)
    })
    if (this.savedData) {
      if (this.savedData.license) {
        this.license.setValue(this.savedData.license)
      }
    }
  }

  ngOnDestroy(): void {
    // save data if its valid, dirty and not submitted
    if (this.submitted === false && this.form.dirty && this.form.valid) {
      this.saveData()
    }
  }

  setTitle(): void {
    this.translate
      .get(['common.serviceName', 'titles.addMaterial.main', 'titles.addMaterial.license'])
      .subscribe((translations: { [key: string]: string }) => {
        this.titleService.setTitle(
          `${translations['titles.addMaterial.main']}: ${translations['titles.addMaterial.license']} - ${translations['common.serviceName']}`
        )
      })
  }

  get license(): FormControl {
    return this.form.get('license') as FormControl
  }

  onSubmit(): void {
    this.submitted = true
    if (this.form.valid) {
      if (this.form.dirty) {
        this.saveData()
      }
      void this.router.navigate(['/lisaa-oppimateriaali', 6])
    }
  }

  saveData(): void {
    const data = Object.assign(
      {},
      JSON.parse(sessionStorage.getItem(storageKeys.newERLSKey)),
      this.form.value
    )

    // save data to session storage
    sessionStorage.setItem(storageKeys.newERLSKey, JSON.stringify(data))
  }

  previousTab(): void {
    void this.router.navigate(['/lisaa-oppimateriaali', 4])
  }

  abort(): void {
    this.abortEdit.emit(true)
  }
}
